import { t } from 'i18next';

export const dashboardPagesMenu = {
	evohunt: {
		id: 'evohunt',
		text: 'Landing',
		path: '/',
		icon: 'Dashboard',
		subMenu: null,
	},
	companyPreview: {
		id: 'companyPreview',
		text: 'Company Preview',
		path: '/preview',
		icon: 'Dashboard',
		subMenu: null,
	},
	termsAndConditions: {
		id: 'termsAndConditions',
		text: 'termsAndConditions',
		path: '/terms-and-conditions',
		icon: 'termsAndConditions',
		subMenu: null,
	},
	privacyPolicy: {
		id: 'privacyPolicy',
		text: 'privacyPolicy',
		path: '/privacy-policy',
		icon: 'privacyPolicy',
		subMenu: null,
	},
	cookiesPolicy: {
		id: 'cookiesPolicy',
		text: 'cookiesPolicy',
		path: '/cookies-policy',
		icon: 'cookiesPolicy',
		subMenu: null,
	},
	candidatePreview: {
		id: 'candidatePreview',
		text: 'Candidate Preview',
		path: '/candidate-preview',
		icon: 'Dashboard',
		subMenu: null,
	},
	queryResultPreview: {
		id: 'queryResultPreview',
		text: 'queryResultPreview',
		path: '/query-result-preview',
		icon: 'Dashboard',
		subMenu: null,
	},
	blindPreview: {
		id: 'blindPreview',
		text: 'Candidate Preview',
		path: '/blind-preview',
		icon: 'Dashboard',
		subMenu: null,
	},
	ideaPreview: {
		id: 'ideaPreview',
		text: 'Idea Preview',
		path: '/idea-preview',
		icon: 'Dashboard',
		subMenu: null,
	},
	dashboard: {
		id: 'dashboard',
		text: 'Dashboard',
		path: '/',
		icon: 'Dashboard',
		subMenu: null,
	},
	dashboardBooking: {
		id: 'dashboard-booking',
		text: 'Dashboard Booking',
		path: 'dashboard-booking',
		icon: 'emoji_transportation',
		subMenu: null,
	},
	crmDashboard: {
		id: 'crmDashboard',
		text: 'CRM Dashboard',
		path: 'crm/dashboard',
		icon: 'RecentActors',
	},
	summary: {
		id: 'summary',
		text: 'Summary',
		path: 'summary',
		icon: 'sticky_note_2',
		subMenu: null,
	},
};

export const evoHuntPages = {
	evohunt: {
		id: 'evohunt',
		text: 'EvoHunt',
		path: 'evohunt',
		icon: null,
		subMenu: {
			login: {
				id: 'login',
				text: 'Login',
				path: 'Login',
				icon: null,
			},
			candidatoIdeatoreSignup: {
				id: 'candidatoIdeatore',
				text: 'Signup',
				path: 'Signupci',
				icon: null,
			},
			signupFromCompany: {
				id: 'signupFromCompany',
				text: 'signupFromCompany',
				path: 'registration',
				icon: null,
			},
			aziendaStartupSignup: {
				id: 'aziendaStartup',
				text: 'Signup',
				path: 'Signupas',
				icon: null,
			},
			userProfile: {
				id: 'userProfileCandidato',
				text: 'User Profile',
				path: 'userProfileCandidato',
				icon: null,
			},
			aziendaProfileHome: {
				id: 'aziendaProfileHome',
				text: 'Azienda Profile',
				path: 'aziendaProfileHome',
				icon: null,
			},
			advisorPage: {
				id: 'advisorPage',
				text: 'Advisor Page',
				path: 'advisorPage',
				icon: null,
			},
			advisorDetail: {
				id: 'advisorDetail',
				text: 'Advisor Detail',
				path: 'advisorDetail',
				icon: null,
			},
			dettaglioCandidatoInRicerca: {
				id: 'dettaglioCandidatoInRicerca',
				text: 'Dettaglio Candidato',
				path: 'dettaglioCandidatoInRicerca',
				icon: null,
			},
			userDetail: {
				id: 'userDetail',
				text: 'Dettaglio Candidato',
				path: 'userDetail',
				icon: null,
			},
			userStatisticsSkills: {
				id: 'userStatisticsSkills',
				text: 'Statistiche individuali',
				path: 'userStatisticsSkills',
				icon: null,
			},
			userAssessmentSkills: {
				id: 'userAssessmentSkills',
				text: 'Valutazione competenze',
				path: 'userAssessmentSkills',
				icon: null,
			},
			descrizioneAzienda: {
				id: 'descrizioneAzienda',
				text: 'Descrizione Azienda',
				path: 'descrizioneAzienda',
				icon: null,
			},
			descrizioneAziendaDetail: {
				id: 'descrizioneAziendaDetail',
				text: 'Descrizione Azienda Detail',
				path: 'descrizioneAziendaDetail',
				icon: null,
			},
			linkAziendali: {
				id: 'linkAziendali',
				text: 'Link Aziendali',
				path: 'linkAziendali',
				icon: null,
			},
			datiReferente: {
				id: 'datiReferente',
				Text: 'Dati Referente',
				path: 'datiReferente',
				icon: null,
			},
			CuriositaPage: {
				id: 'CuriositaPage',
				text: 'Curiosità',
				path: 'CuriositaPage',
				icon: null,
			},
			FaqPage: {
				id: 'faqPage',
				text: 'FAQ',
				path: 'faqPage',
				icon: null,
			},
			scelte: {
				id: 'scelte',
				text: 'Scelte',
				path: 'scelte',
				icon: null,
			},
			studies: {
				id: 'studies',
				text: 'Studies',
				path: 'studies',
				icon: null,
			},
			workingExperiences: {
				id: 'workingExperiences',
				text: 'Working Experiences',
				path: 'workingExperiences',
				icon: null,
			},
			languages: {
				id: 'languages',
				text: 'Languages',
				path: 'languages',
				icon: null,
			},
			volounteers: {
				id: 'volounteers',
				text: 'Volounteers',
				path: 'volounteers',
				icon: null,
			},
			payment: {
				id: 'payment',
				text: 'Payment',
				path: 'payment',
				icon: null,
			},
			benefit: {
				id: 'benefit',
				text: 'benefit',
				path: 'benefit',
				icon: null,
			},
			companyGroup: {
				id: 'companyGroup',
				text: 'companyGroup',
				path: 'companyGroup',
				icon: null,
			},
			companyStudentStudy: {
				id: 'companyStudentStudy',
				text: 'companyStudentStudy',
				path: 'companyStudentStudy',
				icon: null,
			},
			companyUsers: {
				id: 'companyUsers',
				text: 'companyUsers',
				path: 'companyUsers',
				icon: null,
			},
			companyAlias: {
				id: 'companyAlias',
				text: 'companyAlias',
				path: 'companyAlias',
				icon: null,
			},
			widget: {
				id: 'widget',
				text: 'Widget',
				path: 'widget',
				icon: null,
			},
			invoices: {
				id: 'invoices',
				text: 'invoices',
				path: 'invoices',
				icon: null,
			},
			statistics: {
				id: 'statistics',
				text: 'Statistics',
				path: 'statistics',
				icon: null,
			},
			competenze: {
				id: 'competenze',
				text: 'Competenze',
				path: 'competenze',
				icon: null,
			},
			certifications: {
				id: 'certifications',
				text: 'Certifications',
				path: 'certifications',
				icon: null,
			},
			courses: {
				id: 'courses',
				text: 'Courses',
				path: 'courses',
				icon: null,
			},
			jobsLookingFor: {
				id: 'jobsLookingFor',
				text: 'Jobs Looking For',
				path: 'jobsLookingFor',
				icon: null,
			},
			viewCompanyOffer: {
				id: 'viewCompanyOffer',
				text: 'View Company Offer',
				path: 'viewCompanyOffer',
				icon: null,
			},
			viewIdeatorOffer: {
				id: 'viewIdeatorOffer',
				text: 'View Ideator Offer',
				path: 'viewIdeatorOffer',
				icon: null,
			},
			viewStartupOffer: {
				id: 'viewStartupOffer',
				text: 'View Startup Offer',
				path: 'viewStartupOffer',
				icon: null,
			},
			userStatsArea: {
				id: 'userStatsArea',
				text: 'Stats Area',
				path: 'userStatsArea',
				icon: null,
			},
			starteamArea: {
				id: 'starteamArea',
				text: 'Starteam Area',
				path: 'starteamArea',
				icon: null,
			},
			creativaArea: {
				id: 'creativaArea',
				text: 'Creativa Area',
				path: 'creativaArea',
				icon: null,
			},
			workTrainingArea: {
				id: 'workTrainingArea',
				text: 'Work Training Area',
				path: 'workTrainingArea',
				icon: null,
			},
			cVAndIDArea: {
				id: 'cVAndIDArea',
				text: 'CV And ID Area',
				path: 'cVAndIDArea',
				icon: null,
			},
			coursesWithDetail: {
				id: 'coursesWithDetail',
				text: 'Courses With Detail',
				path: 'coursesWithDetail',
				icon: null,
			},
			courseDetail: {
				id: 'courseDetail',
				text: 'Course Detail',
				path: 'courseDetail',
				icon: null,
			},
			ideas: {
				id: 'ideas',
				text: 'Ideas',
				path: 'ideas',
				icon: null,
			},
			ideaDetail: {
				id: 'ideaDetail',
				text: 'Idea Detail',
				path: 'ideaDetail',
				icon: null,
			},
			motivations: {
				id: 'motivations',
				text: 'Motivations',
				path: 'motivations',
				icon: null,
			},
			insertUpdate: {
				id: 'insertUpdate',
				text: 'Insert Update',
				path: 'insertUpdate',
				icon: null,
			},
			testForm: {
				id: 'testForm',
				text: 'Test Form',
				path: 'testForm',
				icon: null,
			},
			savedTest: {
				id: 'savedTest',
				text: 'Saved Test',
				path: 'savedTest',
				icon: null,
			},
			patenti: {
				id: 'patenti',
				text: 'Patenti',
				path: 'patenti',
				icon: null,
			},
			setSteps: {
				id: 'setSteps',
				text: 'Set Steps',
				path: 'setSteps',
				icon: null,
			},
			testVideoEmployee: {
				id: 'testVideoEmployee',
				text: 'testVideoEmployee',
				path: 'testVideoEmployee',
				icon: null,
			},
			ricerca: {
				id: 'ricerca',
				text: 'Ricerca',
				path: 'ricerca',
				icon: null,
				subMenu: {
					ricercaConArchetipo: {
						id: 'ricercaConArchetipo',
						text: 'Ricerca Con Archetipo',
						path: 'ricercaConArchetipo',
						icon: null,
					},
					ricercaPersonalizzata: {
						id: 'ricercaPersonalizzata',
						text: 'Ricerca Personalizzata',
						path: 'ricercaPersonalizzata',
						icon: null,
					},
					addStudyPage: {
						id: 'addStudyPage',
						text: 'AddStudyPage',
						path: 'addStudyPage',
						icon: null,
					},
					addExperiencePage: {
						id: 'addExperiencePage',
						text: 'Aggiungi Esperienza',
						path: 'addExperiencePage',
						icon: null,
					},
					addCompetencePage: {
						id: 'addCompetencePage',
						text: 'Aggiungi Competenza',
						path: 'addCompetencePage',
						icon: null,
					},
					addLanguagePage: {
						id: 'addLanguagePage',
						text: 'Aggiungi Lingua',
						path: 'addLanguagePage',
						icon: null,
					},
					addSoftSkillPage: {
						id: 'addSoftSkillPage',
						text: 'Aggiungi Soft Skill',
						path: 'addSoftSkillPage',
						icon: null,
					},
					addCoursePage: {
						id: 'addCoursePage',
						text: 'Aggiungi Corso',
						path: 'addCoursePage',
						icon: null,
					},
					addCertificationPage: {
						id: 'addCertificationPage',
						text: 'Aggiungi Certificazione',
						path: 'addCertificationPage',
						icon: null,
					},
				},
			},
			hobbySports: {
				id: 'hobbySports',
				text: 'HobbySports',
				path: 'hobbySports',
				icon: null,
				subMenu: {
					hobbies: {
						id: 'hobbies',
						text: 'Hobbies',
						path: 'hobbies',
						icon: null,
					},
					sports: {
						id: 'sports',
						text: 'Sports',
						path: 'sports',
						icon: null,
					},
				},
			},
			hobby: {
				id: 'hobbies',
				text: 'Hobbies',
				path: 'hobbies',
				icon: null,
			},
			sport: {
				id: 'sports',
				text: 'Sports',
				path: 'sports',
				icon: null,
			},
			certificationsOpenBadge: {
				id: 'certificationsOpenBadge',
				text: 'CertificationsOpenBadge',
				path: 'certificationsOpenBadge',
				icon: null,
				subMenu: {
					certifications: {
						id: 'certifications',
						text: 'Certifications',
						path: 'certifications',
						icon: null,
					},
					openBadges: {
						id: 'openBadges',
						text: 'OpenBadges',
						path: 'openBadges',
						icon: null,
					},
				},
			},
			descrizioneCandidatoTabbed: {
				id: 'descrizioneCandidatoTabbed',
				text: 'Descrizione Candidato Tabbed',
				path: 'descrizioneCandidatoTabbed',
				icon: null,
			},
			descrizioneCandidatoEdit: {
				id: 'descrizioneCandidatoEdit',
				text: 'Descrizione Candidato Tabbed',
				path: 'descrizioneCandidatoEdit',
				icon: null,
			},
			descriptionProfileCandidatoDetail: {
				id: 'descriptionProfileCandidatoDetail',
				text: 'Description User Profile Detail',
				path: 'descriptionProfileCandidatoDetail',
				icon: null,
			},
			descriptionProfileCandidato: {
				id: 'descriptionProfileCandidato',
				text: 'Description User Profile',
				path: 'descriptionProfileCandidato',
				icon: null,
			},
			homeCandidato: {
				id: 'homeCandidato',
				text: 'Home Candidato',
				path: 'homeCandidato',
				icon: null,
				subMenu: {
					applicationsPage: {
						id: 'applicationsPage',
						text: 'Applications Page',
						path: 'applicationsPage',
						icon: null,
					},
				},
			},
			homeAzienda: {
				id: 'homeAzienda',
				text: 'Home Azienda',
				path: 'homeAzienda',
				icon: null,
			},
			homeIdeatore: {
				id: 'homeIdeatore',
				text: 'Home Ideatore',
				path: 'homeIdeatore',
				icon: null,
			},
			homeStartup: {
				id: 'homeStartup',
				text: 'Home Startup',
				path: 'homeStartup',
				icon: null,
			},
			interviewsCalendar: {
				id: 'interviewsCalendar',
				text: 'interviewsCalendar',
				path: 'interviewsCalendar',
				icon: null,
			},
			userProfileStartup: {
				id: 'userProfileStartup',
				text: 'User Profile Startup',
				path: 'userProfileStartup',
				icon: null,
			},
			candidatureTestVideoEducational: {
				id: 'candidatureTestVideoEducational',
				text: 'Candidature TestVideo Educational',
				path: 'candidatureTestVideoEducational',
				icon: null,
				subMenu: {
					educational: {
						id: 'educational',
						text: 'educational',
						path: 'educational',
						icon: null,
					},
					testVideo: {
						id: 'testVideo',
						text: 'Test Video',
						path: 'testVideo',
						icon: null,
						subMenu: {
							videoArea: {
								id: 'videoArea',
								text: 'Video Area',
								path: 'videoArea',
								icon: null,
							},
							testArea: {
								id: 'testArea',
								text: 'Test Area',
								path: 'testArea',
								icon: null,
							},
							testResults: {
								id: 'testResults',
								text: 'Test Results',
								path: 'testResults',
								icon: null,
							},
						},
					},
				},
			},
			messaggi: {
				id: 'messaggi',
				text: 'Messaggi',
				path: 'messaggi',
				icon: null,
			},
			messaggio: {
				id: 'messaggio',
				text: 'Messaggio',
				path: 'messaggio',
				icon: null,
			},
			chatSupporto: {
				id: 'chatSupporto',
				text: 'Chat Supporto',
				path: 'chatSupporto',
				icon: null,
			},
			softSkill: {
				id: 'softSkill',
				text: 'Soft Skill',
				path: 'softSkill',
				icon: null,
			},
			ricercheArchiviate: {
				id: 'ricercheArchiviate',
				text: 'Ricerche Archiviate',
				path: 'ricercheArchiviate',
				icon: null,
			},
			ricercheTerminate: {
				id: 'ricercheTerminate',
				text: 'Ricerche Terminate',
				path: 'ricercheTerminate',
				icon: null,
			},
			createTeam: {
				id: 'createTeam',
				text: 'Create Team',
				path: 'createTeam',
				icon: null,
			},
			planner: {
				id: 'planner',
				text: 'Planner',
				path: 'planner',
				icon: null,
			},
			compareCandidates: {
				id: 'compareCandidates',
				text: 'Compare Candidates',
				path: 'compareCandidates',
				icon: null,
			},
			queryCandidateList: {
				id: 'queryCandidateList',
				text: 'Query Candidate List',
				path: 'queryCandidateList',
				icon: null,
			},
			queryDetail: {
				id: 'queryDetail',
				text: 'Query Detail',
				path: 'queryDetail',
				icon: null,
			},
			richiediVideoAzienda: {
				id: 'requestVideo',
				text: 'Richiedi Video Azienda',
				path: 'requestVideo',
				icon: null,
			},
			richiediTestAzienda: {
				id: 'requestTest',
				text: 'Richiedi Test Azienda',
				path: 'requestTest',
				icon: null,
			},
			settings: {
				id: 'settings',
				text: 'Impostazioni',
				path: 'settings',
				icon: null,
			},
			changeLanguage: {
				id: 'changeLanguage',
				text: 'Cambio lingua',
				path: 'change-language',
				icon: null,
			},
			changePassword: {
				id: 'changePassword',
				text: 'Cambio password',
				path: 'change-password',
				icon: null,
			},
			savedTests: {
				id: 'savedTests',
				text: 'Saved Tests',
				path: 'savedTests',
				icon: null,
			},
			iMieiTeam: {
				id: 'iMieiTeam',
				text: 'I Miei Team',
				path: 'iMieiTeam',
				icon: null,
			},
			notifiche: {
				id: 'notifiche',
				text: 'Notifiche',
				path: 'notifiche',
				icon: null,
			},
			candidateResearch: {
				id: 'candidateResearch',
				text: 'Cerca candidati',
				path: 'candidateResearch',
				icon: null,
			},
			detailOfferTabbed: {
				id: 'detailOfferTabbed',
				text: 'Dettaglio Offerta',
				path: 'detailOfferTabbed',
				icon: null,
			},
			queryTestVideo: {
				id: 'queryTestVideo',
				text: 'Test & Video',
				path: 'queryTestVideo',
				icon: null,
			},
			queryTestVideoTabbed: {
				id: 'queryTestVideoTabbed',
				text: 'Test & Video',
				path: 'queryTestVideoTabbed',
				icon: null,
			},
			queryTestDetail: {
				id: 'queryTestDetail',
				text: 'Test',
				path: 'queryTestDetail',
				icon: null,
			},
			advisor: {
				id: 'advisor',
				text: 'Advisor',
				path: 'advisor',
				icon: null,
			},
			tipsTabbed: {
				id: 'tipsTabbed',
				text: 'Tips',
				path: 'tipsTabbed',
				icon: null,
			},
			video: {
				id: 'video',
				text: 'video',
				path: 'video',
				icon: null,
			},
			testVideoTabbed: {
				id: 'testVideoTabbed',
				text: 'TestVideo',
				path: 'testVideoTabbed',
				icon: null,
			},
			companyTestVideo: {
				id: 'companyTestVideo',
				text: 'companyTestVideo',
				path: 'companyTestVideo',
				icon: null,
			},
			viewTestPage: {
				id: 'viewTestPage',
				text: 'ViewTest',
				path: 'viewTestPage',
				icon: null,
			},
			viewCompletedTestPage: {
				id: 'viewCompletedTestPage',
				text: 'ViewCompletedTest',
				path: 'viewCompletedTestPage',
				icon: null,
			},
			companyTeamPage: {
				id: 'companyTeamPage',
				text: 'CompanyTeam',
				path: 'companyTeamPage',
				icon: null,
			},
			companyTeamDetailPage: {
				id: 'companyTeamDetailPage',
				text: 'CompanyTeamDetail',
				path: 'companyTeamDetailPage',
				icon: null,
			},
			companyTeamSkillDetailPage: {
				id: 'companyTeamSkillDetailPage',
				text: 'CompanyTeamSkillDetail',
				path: 'companyTeamSkillDetailPage',
				icon: null,
			},
			companyTeamPersonalisedSearch: {
				id: 'companyTeamPersonalisedSearch',
				text: 'CompanyTeamPersonalisedSearch',
				path: 'companyTeamPersonalisedSearch',
				icon: null,
			},
			companyTeamSearchDetail: {
				id: 'companyTeamSearchDetail',
				text: 'CompanyTeamSearchDetail',
				path: 'companyTeamSearchDetail',
				icon: null,
			},
			companyTeamSearchDetailParametersPage: {
				id: 'companyTeamSearchDetailParametersPage',
				text: 'CompanyTeamSearchDetailParametersPage',
				path: 'companyTeamSearchDetailParametersPage',
				icon: null,
			},
			companyTeamStatisticPage: {
				id: 'companyTeamStatisticPage',
				text: 'CompanyTeamStatisticPage',
				path: 'companyTeamStatisticPage',
				icon: null,
			},
			evaluateCompetencesPage: {
				id: 'evaluateCompetencesPage',
				text: 'EvaluateCompetencesPage',
				path: 'evaluateCompetencesPage',
				icon: null,
			},
			teamComponentCompetencePage: {
				id: 'teamComponentCompetencePage',
				text: 'TeamComponentCompetencePage',
				path: 'teamComponentCompetencePage',
				icon: null,
			},
			teamComponentStatisticPage: {
				id: 'teamComponentStatisticPage',
				text: 'TeamComponentStatisticPage',
				path: 'teamComponentStatisticPage',
				icon: null,
			},
			teamSearchResultsPage: {
				id: 'teamSearchResultsPage',
				text: 'TeamSearchResultsPage',
				path: 'teamSearchResultsPage',
				icon: null,
			},
			teamSearchEditPage: {
				id: 'teamSearchEditPage',
				text: 'teamSearchEditPage',
				path: 'teamSearchEditPage',
				icon: null,
			},
			editCompanySearchResults: {
				id: 'editCompanySearchResults',
				text: 'EditCompanySearchResults',
				path: 'editCompanySearchResults',
				icon: null,
			},
			companyMap: {
				id: 'companyMap',
				text: 'CompanyMap',
				path: 'companyMap',
				icon: null,
			},
			companyMapDistributionDetail: {
				id: 'companyMapDistributionDetail',
				text: 'CompanyMapDistributionDetail',
				path: 'companyMapDistributionDetail',
				icon: null,
			},
			companyMapEmployeeCommitmentPage: {
				id: 'companyMapEmployeeCommitmentPage',
				text: 'companyMapEmployeeCommitmentPage',
				path: 'companyMapEmployeeCommitmentPage',
				icon: null,
			},
			companyMapEmployeesPage: {
				id: 'companyMapEmployeesPage',
				text: 'CompanyMapEmployeesPage',
				path: 'companyMapEmployeesPage',
				icon: null,
			},
			userDetailPage: {
				id: 'userDetailPage',
				text: 'userDetailPage',
				path: 'userDetailPage',
				icon: null,
			},
			startupStatisticsPage: {
				id: 'startupStatisticsPage',
				text: 'STATISTICHE',
				path: 'startupStatisticsPage',
				icon: null,
			},
			ideatoreStatisticsPage: {
				id: 'ideatoreStatisticsPage',
				text: 'STATISTICHE',
				path: 'ideatoreStatisticsPage',
				icon: null,
			},
			datiReferenteDetail: {
				id: 'datiReferenteDetail',
				Text: 'Dati Referente',
				path: 'datiReferenteDetail',
				icon: null,
			},
			linkAziendaliDetail: {
				id: 'linkAziendaliDetail',
				Text: 'Link Aziendali',
				path: 'linkAziendaliDetail',
				icon: null,
			},
			companySectors: {
				id: 'companySectors',
				Text: 'Settori Aziendali',
				path: 'companySectors',
				icon: null,
			},
			companyAwards: {
				id: 'companyAwards',
				Text: 'Premi Aziendali',
				path: 'companyAwards',
				icon: null,
			},
			companyRewards: {
				id: 'companyRewards',
				Text: 'Riconoscimenti Aziendali',
				path: 'companyRewards',
				icon: null,
			},
			companyImages: {
				id: 'companyImages',
				Text: 'Immagini Aziendali',
				path: 'companyImages',
				icon: null,
			},
			companyLocations: {
				id: 'companyLocations',
				Text: 'Indirizzi Sedi',
				path: 'companyLocations',
				icon: null,
			},
		},
	},
};

export function burgerButtons(role: string) {
	switch (role) {
		case 'USER':
			return [
				{
					id: 'homeCandidato',
					text: t('candidate.burger.home')!,
					path: 'homeCandidato',
					icon: null,
				},
				{
					id: 'userProfileCandidato',
					text: t('candidate.burger.profile')!,
					path: 'userProfileCandidato',
					icon: null,
				},
				{
					id: 'impostazioni',
					text: t('candidate.burger.settings')!,
					path: 'settings',
					icon: null,
				},
				{
					id: 'changePassword',
					text: t('candidate.burger.change-password')!,
					path: 'change-password',
					icon: null,
				},
			];
		case 'IDEATOR':
			return [
				{
					id: 'homeIdeatore',
					text: 'HOME',
					path: 'homeIdeatore',
					icon: null,
				},
				{
					id: 'userProfileIdeatore',
					text: 'PROFILO',
					path: 'userProfileIdeatore',
					icon: null,
				},
				{
					id: 'sviluppo',
					text: 'SVILUPPO',
					path: 'sviluppo',
					icon: null,
				},
				{
					id: 'nuovaRicerca',
					text: 'NUOVA RICERCA',
					path: 'ricerca',
					icon: null,
				},
				/*{
					id: 'chatSupporto',
					text: 'CHAT DI SUPPORTO',
					path: 'chatSupporto',
					icon: null,
				},*/
				{
					id: 'ideatoreStatisticsPage',
					text: 'STATISTICHE',
					path: 'ideatoreStatisticsPage',
					icon: null,
				},
				{
					id: 'impostazioni',
					text: 'IMPOSTAZIONI',
					path: 'settings',
					icon: null,
				},
				{
					id: 'changePassword',
					text: 'CAMBIO PASSWORD',
					path: 'change-password',
					icon: null,
				},
			];
		case 'COMPANY':
			return [
				{
					id: 'homeAzienda',
					text: t('company.burger.home')!,
					path: 'homeAzienda',
					icon: null,
				},
				{
					id: 'aziendaProfileHome',
					text: t('company.burger.profile')!,
					path: 'aziendaProfileHome',
					icon: null,
				},
				/*{
					id: 'programmazioneAttivita',
					text: 'PROGRAMMAZIONE ATTIVITA',
					path: 'planner',
					icon: null,
				},
				{
					id: 'chatSupporto',
					text: 'CHAT DI SUPPORTO',
					path: 'chatSupporto',
					icon: null,
				},*/
				{
					id: 'nuovaRicerca',
					text: t('company.burger.new-query')!,
					path: 'ricerca',
					icon: null,
				},
				{
					id: 'companyMap',
					text: t('company.burger.map')!,
					path: 'companyMap',
					icon: null,
				},
				{
					id: 'statistics',
					text: t('company.burger.statistics')!,
					path: 'statistics',
					icon: null,
				},
				{
					id: 'impostazioni',
					text: t('company.burger.settings')!,
					path: 'settings',
					icon: null,
				},
				{
					id: 'changePassword',
					text: t('company.burger.change-password')!,
					path: 'change-password',
					icon: null,
				},
				{
					id: 'changeLanguage',
					text: t('company.burger.change-language')!,
					path: 'change-language',
					icon: null,
				},
			];
		case 'STARTUP':
		default:
			return [
				{
					id: 'homeStartup',
					text: 'HOME',
					path: 'homeStartup',
					icon: null,
				},
				{
					id: 'userProfileStartup',
					text: 'PROFILO',
					path: 'userProfileStartup',
					icon: null,
				},
				/*{
					id: 'chatSupporto',
					text: 'CHAT DI SUPPORTO',
					path: 'chatSupporto',
					icon: null,
				},*/
				{
					id: 'nuovaRicerca',
					text: 'NUOVA RICERCA',
					path: 'ricerca',
					icon: null,
				},
				{
					id: 'startupStatisticsPage',
					text: 'STATISTICHE',
					path: 'startupStatisticsPage',
					icon: null,
				},
				{
					id: 'impostazioni',
					text: 'IMPOSTAZIONI',
					path: 'settings',
					icon: null,
				},
				{
					id: 'changePassword',
					text: 'CAMBIO PASSWORD',
					path: 'change-password',
					icon: null,
				},
			];
	}
}
